import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './search.svg'
import _imports_1 from './plus.svg'


_pushScopeId("data-v-6026dcb0")
const _hoisted_1 = {
  class: "container mx-auto",
  id: "hot-pools"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "mx-7 my-7 font-semibold" }, "Super Hot Pools", -1)
const _hoisted_3 = { class: "mt-[81px] pt-10 md:pt-12 xl:container xl:mx-auto " }
const _hoisted_4 = {
  key: 0,
  class: "flex w-full flex-col items-end justify-between md:flex-row lg:items-center mb-0"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-[12px]"
}, null, -1)
const _hoisted_6 = { class: "pool-types flex flex-1 items-center gap-[8px] pl-[12px] pr-[16px]" }
const _hoisted_7 = { href: "#segniorage" }
const _hoisted_8 = { href: "#classicpools" }
const _hoisted_9 = { href: "#communitypools" }
const _hoisted_10 = { href: "#singlestaking" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-[8px]"
}, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, "Create a pool", -1)
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "flex w-full items-center rounded-[12px] bg-[#261737] px-[24px] pb-[9px] pt-[9px] pl-[16px]" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mr-[12px]"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "mr-[8px]"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", null, "Create a pool", -1)
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
const _hoisted_21 = { class: "mt-[8px] flex justify-center gap-[8px] px-5" }
const _hoisted_22 = { href: "#segniorage" }
const _hoisted_23 = { href: "#classicpools" }
const _hoisted_24 = { href: "#communitypools" }
const _hoisted_25 = { href: "#singlestaking" }
const _hoisted_26 = { id: "classicpools" }
const _hoisted_27 = { id: "communitypools" }
const _hoisted_28 = { id: "singlestaking" }
_popScopeId()

import { watch,Ref } from 'vue';
import { useRouter } from 'vue-router';

import HomePageHero from '@/components/heros/HomePageHero.vue';
import TokenSearchInput from '@/components/inputs/TokenSearchInput.vue';
import FeaturedProtocols from '@/components/sections/FeaturedProtocols.vue';
import PoolsTable from '@/components/tables/PoolsTable/PoolsTable.vue';
import PoolCard from '@/components/cards/PoolCard/PoolCard.vue';
import ClaimCard from '@/components/cards/ClaimCard/ClaimCard.vue';
import usePoolFilters from '@/composables/pools/usePoolFilters';
import useStreamedPoolsQuery from '@/composables/queries/useStreamedPoolsQuery';
import useBreakpoints from '@/composables/useBreakpoints';
import useWeb3 from '@/services/web3/useWeb3';

import segniorageImg from './pool-icon-seigniorage.svg';
import classicImg from './pool-icon-classic.svg';
import communityImg from './pool-icon-community.svg';
import { InvestmentPool } from '@balancer-labs/typechain';

import { TOKENS } from '@/constants/tokens';
import SingleStake from './SingleStakeTable.vue';


function setup(__props) {

const { priceQueryLoading, tokens, getTokens, prices } = useTokens();

// COMPOSABLES
const router = useRouter();
const { appNetworkConfig } = useWeb3();
const isElementSupported = appNetworkConfig.supportsElementPools;
const { selectedTokens, addSelectedToken, removeSelectedToken } =
  usePoolFilters();


const {
  dataStates,
  result: investmentPools,
  loadMore,
  isLoadingMore,
} = useStreamedPoolsQuery(selectedTokens);
const { upToMediumBreakpoint, isMobile, isDesktop } = useBreakpoints();

const isInvestmentPoolsTableLoading = computed(
  () => dataStates.value['basic'] === 'loading' || priceQueryLoading.value
);


const segniorageIds = [
  '0xd88a378abfe6b6e232525dfb03fbe01ecc863c10000200000000000000000004',
  '0xa83f9fa9b51fc26e9925a07bc3375617b473e051000200000000000000000005',
  '0xa215a58225b344cbb62fcf762e8e884dbedfbe58000200000000000000000006',
  '0x293bbbef6087f681a8110f08bbdedadd13599fc3000200000000000000000007',
  '0x0993fa12d3256e85da64866354ec3532f187e178000200000000000000000008',
  '0xf0b6cf745afe642c4565165922ad62d6a93857c100020000000000000000000e',
];

const classicPoolsIds = [
  '0x244caf21eaa7029db9d6b42ddf2d95800a2f5eb500020000000000000000000a',
  '0x9cd44e44e8a61bc7dc34b04c762a3c0137a3707c000200000000000000000002',
  '0xfbfcd8d689a3689db0f35277bf7cc11663a672e000020000000000000000000b',
  '0xb3a04902b78fbe61185b766866193630db4db8a300020000000000000000000d',
  '0x24f58ab36c212e54b248ebfb17eff2ca21dc95d5000200000000000000000013',
  '0x4200333dc021ea5fb1050b8e4f8f3ed7cb1d22ed00020000000000000000000c',
  '0xd8e9e1916a4d98fb0dc6db725a8c8c2af08a329b00020000000000000000000f',
  '0x8bd71de52a3be3aadeb375f8d69aed37adf83d80000200000000000000000010',
  '0xceecce984f498ee00832670e9ca6d372f6ce155a000200000000000000000014',
  '0x23a8a6e5d468e7acf4cc00bd575dbecf13bc7f78000100000000000000000015',
  '0x454adaa07eec2c432c0df4379a709b1fa4c800ed000200000000000000000016',
  '0x89cc63050ade84bffafd7ec84d24fc0feb5f96c9000200000000000000000020',
  '0xe370d4d0727d4e9b70db1a2f7d2efd1010ff1d6d000200000000000000000021',
];

const superHotPoolsIds = [
  '0x23a8a6e5d468e7acf4cc00bd575dbecf13bc7f78000100000000000000000015',
  '0x293bbbef6087f681a8110f08bbdedadd13599fc3000200000000000000000007',
  '0xd88a378abfe6b6e232525dfb03fbe01ecc863c10000200000000000000000004',
  '0x0993fa12d3256e85da64866354ec3532f187e178000200000000000000000008',
  '0xe370d4d0727d4e9b70db1a2f7d2efd1010ff1d6d000200000000000000000021',
  '0x244caf21eaa7029db9d6b42ddf2d95800a2f5eb500020000000000000000000a',
  
];

const contains = (arr1, arr2) => {
  for (let el of arr1) {
    if (arr2.includes(el)) return true;
  }

  return false;
};

// const filteredTokensList: String[] = [];

// function filterToken(e) {
//   const filteredToken = e.target.value.toLowerCase();
//   filteredTokensList.length = 0;

//   for (const token of Object.entries(tokens.value)) {
//     const tokenName = token[1].name;
//     const tokenAddress = token[1].address;

//     if (tokenName.toLowerCase().includes(filteredToken)) {
//       filteredTokensList.push(tokenAddress);
//     }
//   }

//   console.log(filteredTokensList);
// }

const segnioragePools = computed(() => {
  return investmentPools.value.filter(pool =>
    segniorageIds.includes(pool.id)
  ) as InvestmentPool[];
});
const investmentPoolsWithoutSeigniorage = computed(
  () =>
    investmentPools.value.filter(pool =>
      classicPoolsIds.includes(pool.id)
    ) as InvestmentPool[]
);

const communityPools = computed(
  () =>
    investmentPools.value.filter(
      pool =>
        !segniorageIds.includes(pool.id) && !classicPoolsIds.includes(pool.id)
    ) as InvestmentPool[]
);
const superHotPools = computed(() => {
  return investmentPools.value.filter(pool =>
    superHotPoolsIds.includes(pool.id)
  ) as InvestmentPool[];
});

/**
 * METHODS
 */
function navigateToCreatePool() {
  router.push({ name: 'create-pool' });
}

let searchTerm = ref('');

const getTokenNames = () => {
  const { tokens } = useTokens();
  const Tokens = Object.entries(tokens.value);
  const tokenList = [] as string[];

  for (const token of Object.entries(Tokens)) {
    const tokenName: string = token[1][1]['symbol'];
    // console.log(token);
    tokenList.push(tokenName);
  }

  return tokenList;
};

const getTokenMapping = () => {
  const { tokens } = useTokens();
  const Tokens = Object.entries(tokens.value);
  const tokenList = {};

  for (const token of Object.entries(Tokens)) {
    const tokenName: string = token[1][1]['symbol'];
    const tokenAddress: string = token[1][1]['address'];
    // console.log(token[1][1]['symbol']);
    tokenList[tokenName] = tokenAddress;
  }

  return tokenList;
};

const mapping = getTokenMapping();

const searchTokens = computed(() => {
  if (searchTerm.value === '') {
    return [];
  }

  const tokenNames = getTokenNames();

  return tokenNames.filter(token => {
    if (token.toLowerCase().includes(searchTerm.value.toLowerCase())) {
      return token;
    }
  });
});

let selectedToken = ref('');

const selectToken = token => {
  selectedToken.value = token;
  searchTerm.value = token;
};


return (_ctx: any,_cache: any) => {
  const _component_BalStack = _resolveComponent("BalStack")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HomePageHero),
    _createVNode(ClaimCard, {
      pools: _unref(segnioragePools).concat(_unref(communityPools)).concat(_unref(investmentPoolsWithoutSeigniorage)),
      prices: _unref(prices)
    }, null, 8, ["pools", "prices"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", {
        class: _normalizeClass(["grid gap-6", {'grid-cols-1':_unref(isMobile), 'grid-cols-3':_unref(isDesktop)}])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(isDesktop)) ? _unref(superHotPools).slice(0, 6) :_unref(superHotPools).slice(0, 3), (pool, idx) => {
          return (_openBlock(), _createBlock(PoolCard, {
            key: idx,
            pool: pool,
            prices: _unref(prices)
          }, null, 8, ["pool", "prices"]))
        }), 128))
      ], 2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_BalStack, { vertical: "" }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            style: _normalizeStyle({ top: _ctx.menuHeight()+ 'px' }),
            class: _normalizeClass(["container px-4 xl:px-0 mb-4 pool-panel", {
            'is-sticky': _ctx.stickyPanel,
            'navbar-bg': _ctx.stickyPanel,
            'not-sticky': !_ctx.stickyPanel,
            'filter-panel-mobile': _unref(isMobile),
          }])
          }, [
            (_unref(isDesktop))
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", {
                    class: "search flex items-center",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.inputFocused = true))
                  }, [
                    _hoisted_5,
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      placeholder: "Filter by token",
                      class: "input w-full",
                      onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.filterToken && _ctx.filterToken(...args))),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(searchTerm) ? searchTerm.value = $event : searchTerm = $event))
                    }, null, 544), [
                      [_vModelText, _unref(searchTerm)]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("a", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer mx-[12px]", {'selected-pool': _ctx.selectedPool =='segniorage'}])
                      }, "Seigniorage Pools", 2)
                    ]),
                    _createElementVNode("a", _hoisted_8, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer mx-[12px]", {'selected-pool': _ctx.selectedPool =='classic'}])
                      }, "Classic Pools", 2)
                    ]),
                    _createElementVNode("a", _hoisted_9, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer mx-[12px]", {'selected-pool': _ctx.selectedPool =='community'}])
                      }, "Community Pools", 2)
                    ]),
                    _createElementVNode("a", _hoisted_10, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer mx-[12px]", {'selected-pool': _ctx.selectedPool =='single'}])
                      }, "Single Staking", 2)
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: "create-pool-btn flex items-center",
                    onClick: navigateToCreatePool
                  }, _hoisted_13)
                ]))
              : _createCommentVNode("", true),
            (_unref(isMobile))
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        placeholder: "Filter by token",
                        class: "input",
                        onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.filterToken && _ctx.filterToken(...args))),
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(searchTerm) ? searchTerm.value = $event : searchTerm = $event))
                      }, null, 544), [
                        [_vModelText, _unref(searchTerm)]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: "create-pool-btn-mobile flex flex-none items-center justify-center ml-5",
                      onClick: navigateToCreatePool
                    }, _hoisted_20)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("a", _hoisted_22, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer px-[9px] py-[16px] text-center", {'selected-pool': _ctx.selectedPool =='segniorage'}])
                      }, "Seigniorage", 2)
                    ]),
                    _createElementVNode("a", _hoisted_23, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer px-[9px] py-[16px] text-center", {'selected-pool': _ctx.selectedPool =='classic'}])
                      }, "Classic", 2)
                    ]),
                    _createElementVNode("a", _hoisted_24, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer px-[9px] py-[16px] text-center", {'selected-pool': _ctx.selectedPool =='community'}])
                      }, "Community", 2)
                    ]),
                    _createElementVNode("a", _hoisted_25, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["pool-type-btn cursor-pointer px-[9px] py-[16px] text-center", {'selected-pool': _ctx.selectedPool =='single'}])
                      }, "Single Staking", 2)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 6),
          _createElementVNode("div", {
            id: "segniorage",
            class: _normalizeClass({
            'mt-[50px]': _ctx.stickyPanel && _unref(isDesktop),
            'mt-[250px]': _ctx.stickyPanel && _unref(isMobile),
          })
          }, [
            _createVNode(PoolsTable, {
              key: _ctx.filteredTokensList,
              data: _unref(segnioragePools),
              noPoolsLabel: _ctx.$t('noPoolsFound'),
              isLoadingMore: _unref(isLoadingMore),
              selectedTokens: _ctx.filteredTokensList,
              class: "mb-8",
              hiddenColumns: ['migrate', 'actions', 'lockEndDate'],
              columnStates: _unref(dataStates),
              isPaginated: true,
              isLoading: _unref(isInvestmentPoolsTableLoading),
              onLoadMore: _unref(loadMore),
              title: 'Seigniorage Pools',
              type: 'seigniorage',
              img: _unref(segniorageImg),
              prices: _unref(prices)
            }, null, 8, ["data", "noPoolsLabel", "isLoadingMore", "selectedTokens", "columnStates", "isLoading", "onLoadMore", "img", "prices"])
          ], 2),
          _createElementVNode("div", _hoisted_26, [
            _createVNode(PoolsTable, {
              key: _ctx.filteredTokensList,
              data: _unref(investmentPoolsWithoutSeigniorage),
              noPoolsLabel: _ctx.$t('noPoolsFound'),
              isLoadingMore: _unref(isLoadingMore),
              selectedTokens: _ctx.filteredTokensList,
              class: "mb-8",
              hiddenColumns: ['migrate', 'actions', 'lockEndDate'],
              columnStates: _unref(dataStates),
              isPaginated: true,
              isLoading: _unref(isInvestmentPoolsTableLoading),
              onLoadMore: _unref(loadMore),
              title: 'Classic Pools',
              prices: _unref(prices),
              type: 'classic',
              img: _unref(classicImg)
            }, null, 8, ["data", "noPoolsLabel", "isLoadingMore", "selectedTokens", "columnStates", "isLoading", "onLoadMore", "prices", "img"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(PoolsTable, {
              key: _ctx.filteredTokensList,
              data: _unref(communityPools),
              noPoolsLabel: _ctx.$t('noPoolsFound'),
              isLoadingMore: _unref(isLoadingMore),
              selectedTokens: _ctx.filteredTokensList,
              class: "mb-8",
              hiddenColumns: ['migrate', 'actions', 'lockEndDate'],
              columnStates: _unref(dataStates),
              isPaginated: true,
              isLoading: _unref(isInvestmentPoolsTableLoading),
              onLoadMore: _unref(loadMore),
              title: 'Community Pools',
              type: 'community',
              img: _unref(communityImg),
              noApr: true
            }, null, 8, ["data", "noPoolsLabel", "isLoadingMore", "selectedTokens", "columnStates", "isLoading", "onLoadMore", "img"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(SingleStake)
          ])
        ]),
        _: 1
      })
    ])
  ], 64))
}
}


import { defineComponent, ref, computed} from 'vue';
import useTokens from '@/composables/useTokens';
import { TokenInfo } from '@/types/TokenList';
import useBreakPoints from '@/composables/useBreakpoints';
var segnioragepools,classicpools,singlepools,communitypools;
const { upToMediumBreakpoint, isMobile, isDesktop } = useBreakPoints();
const __default__ = defineComponent({
  created() {
    const { tokens, getToken } = useTokens();
    this.tokens = Object.entries(tokens.value);
    Object.entries(tokens.value).forEach(token => {
      this.tokenNames[getToken(token[0]).symbol] = token[0];
    });
    window.addEventListener('scroll',this.onScroll);
    
  },
  
  data() {
    return {
      filteredTokensList: [] as string[],
      tokens: [] as [string, TokenInfo][],
      inputFocused: false,
      tokenNames: {},
      stickyPanel: false,
      selectedPool:'segniorage',
      singlepoolsTop:0,
      classicpoolsTop:0,
      segnioragepoolsTop:0,
      communitypoolsTop:0,
    };
  },
  mounted () {
    let vm = this;
    // this.$nextTick(function () {
    //   singlepools = this.$refs['singlepools'];
    //   segnioragepools = this.$refs['segnioragepools'];
    //   classicpools = this.$refs['classicpools'];
    //   communitypools = this.$refs['communitypools'];
    //   console.log(this.$refs['segnioragepools']);
    // });
    
    // singlepools = this.$refs.singlepools;
    // segnioragepools = this.$refs.segnioragepools;
    // classicpools = this.$refs.classicpools;
    // communitypools = this.$refs.communitypools;
    // console.log(this.$refs.segnioragepools);
  },
  methods: {
    filterToken(e) {
      const filteredToken = e.target.value;
      this.filteredTokensList.length = 0;
      const tokens = this.tokens;
      const tokenList = [] as string[];

      for (const token of Object.entries(this.tokenNames)) {
        const tokenName: string = token[0] as string;
        const tokenAddress: string = token[1] as string;

        if (
          tokenName &&
          filteredToken &&
          tokenName.toLowerCase().includes(filteredToken.toLowerCase())
        ) {
          tokenList.push(tokenAddress);
        }
      }

      this.filteredTokensList = tokenList;
    },
    menuHeight(){
      if ( document.querySelector("#menuConatiner")!=undefined && this.stickyPanel)
        return document.querySelector("#menuConatiner")!.getBoundingClientRect().height-1;
      return 0;
    },
    onScroll(){
      if ( document.querySelector("#segniorage")!=undefined && (
        // (document.querySelector("#segniorage")!.getBoundingClientRect().top<250 && isMobile.value) ||
        // (document.querySelector("#segniorage")!.getBoundingClientRect().top<125 && isDesktop.value) 
        (document.querySelector("#segniorage")!.getBoundingClientRect().top<250 && isMobile.value) ||
        (document.querySelector("#segniorage")!.getBoundingClientRect().top < 38 + document.querySelector("#menuConatiner")!.getBoundingClientRect().height && isDesktop.value) 
        )
      ) {
        this.stickyPanel = true;
      } else {
        this.stickyPanel = false;
      }
      
      
      if(document.querySelector("#singlestaking") != undefined &&  document.querySelector("#singlestaking")!.getBoundingClientRect().top<100){
        this.selectedPool = 'single';
      }
      else if(document.querySelector("#communitypools") != undefined && document.querySelector("#communitypools")!.getBoundingClientRect().top<100){
        this.selectedPool = 'community';
      }
      else if(document.querySelector("#classicpools") != undefined && document.querySelector("#classicpools")!.getBoundingClientRect().top<100){
        this.selectedPool = 'classic';
      }
      else if(document.querySelector("#segniorage") != undefined && document.querySelector("#segniorage")!.getBoundingClientRect().top<100){
        this.selectedPool = 'segniorage';
      }
    },
  },
  watch:{
  },
});

export default _defineComponent({
  ...__default__,
  setup})